export const OPS_MILESTONE_STATUS = {
  PENDING: "pending",
  OVERDUE_INCOMPLETE: "overdue_incomplete",
  COMPLETED_AHEAD: "completed_ahead",
  COMPLETED_ON_TIME: "completed_on_time",
  COMPLETED_LATE: "completed_late",
  MISSING_DATE: "missing_date",
};

export const OPS_MILESTONE_COLORS = {
  pending: {
    background: "#ffffff",
    border: "#d1d5db",
    badgeBackground: "#f3f4f6",
    badgeColor: "#374151",
    label: "Pending",
  },
  overdue_incomplete: {
    background: "#fde8ee",
    border: "#f4a3b5",
    badgeBackground: "#f4a3b5",
    badgeColor: "#4c0519",
    label: "Overdue",
  },
  completed_ahead: {
    background: "#e0efff",
    border: "#4891db",
    badgeBackground: "#4891db",
    badgeColor: "#eff6ff",
    label: "Done Ahead",
  },
  completed_on_time: {
    background: "#eeeafb",
    border: "#9e9ac8",
    badgeBackground: "#9e9ac8",
    badgeColor: "#ffffff",
    label: "Done",
  },
  completed_late: {
    background: "#eeeafb",
    border: "#9e9ac8",
    badgeBackground: "#9e9ac8",
    badgeColor: "#ffffff",
    label: "Done Late",
  },
  missing_date: {
    background: "#ffffff",
    border: "#d1d5db",
    badgeBackground: "#f3f4f6",
    badgeColor: "#374151",
    label: "No Date",
  },
};

export function todayIsoDate() {
  return new Date().toISOString().slice(0, 10);
}

export function deriveOpsMilestoneStatus({ plannedFinish, completedDate, todayIso = todayIsoDate() }) {
  if (completedDate) {
    if (!plannedFinish) return OPS_MILESTONE_STATUS.COMPLETED_ON_TIME;
    if (completedDate < plannedFinish) {
      return todayIso < plannedFinish
        ? OPS_MILESTONE_STATUS.COMPLETED_AHEAD
        : OPS_MILESTONE_STATUS.COMPLETED_ON_TIME;
    }
    if (completedDate === plannedFinish) return OPS_MILESTONE_STATUS.COMPLETED_ON_TIME;
    return OPS_MILESTONE_STATUS.COMPLETED_LATE;
  }

  if (plannedFinish && plannedFinish < todayIso) {
    return OPS_MILESTONE_STATUS.OVERDUE_INCOMPLETE;
  }

  if (plannedFinish) return OPS_MILESTONE_STATUS.PENDING;
  return OPS_MILESTONE_STATUS.MISSING_DATE;
}

export function getOpsMilestoneColor(status) {
  return OPS_MILESTONE_COLORS[status] || OPS_MILESTONE_COLORS.pending;
}
